import { ComponentType as f } from "../../registries/types/propTypes.js";
const _ = (o) => {
  var e, i, n, m, c, s, p, u, C, g;
  let r = {};
  return o && (r = {
    imageList: (i = (e = o == null ? void 0 : o.image) == null ? void 0 : e.images) == null ? void 0 : i.map((l) => ({
      url: l.image.url,
      altText: l.alt_text,
      viewport: l.viewport
    })),
    tag: o == null ? void 0 : o.tag,
    title: o == null ? void 0 : o.display_title,
    description: o == null ? void 0 : o.description,
    backgroundColor: (n = o == null ? void 0 : o.background_color) == null ? void 0 : n.color,
    color: (m = o == null ? void 0 : o.text_color) == null ? void 0 : m.color,
    themeColor: (s = (c = o == null ? void 0 : o.theme_color) == null ? void 0 : c.color) == null ? void 0 : s.color,
    themeShade: (u = (p = o == null ? void 0 : o.theme_color) == null ? void 0 : p.theme) == null ? void 0 : u.theme,
    url: (C = o == null ? void 0 : o.link) == null ? void 0 : C.url,
    target: (g = o == null ? void 0 : o.link) == null ? void 0 : g.target
  }), {
    ...r
  };
}, t = (o) => {
  const r = _(o);
  let e = {};
  return o && (e = {
    subTitle: o == null ? void 0 : o.sub_title
  }), {
    componentType: f.article_card,
    ...r,
    ...e
  };
};
export {
  t as default,
  _ as transformContentCardCommonData
};
//# sourceMappingURL=article-card-transformer.js.map
